import { classNames } from 'libs/react';
import { useRef } from 'libs/react';
import { useState } from 'libs/react';
import { FormCheck } from './FormCheck';
import { FormField } from './FormField';
import { FormGroup } from './FormGroup';
import { Button } from 'components/Button';
import { ButtonGroup } from 'components/ButtonGroup';
import { FormFieldInfos } from 'components/form/FormFieldInfos';
import { FormFieldLabel } from 'components/form/FormFieldLabel';
import { Case } from 'components/util/Case';
import { Else } from 'components/util/Else';
import { When } from 'components/util/When';
import { React } from 'libs/react';
import './FormDelete.scss';
/**
 * @component FormDelete
 * @since 1.0.0
 */
export function FormDelete(props) {
    const { style, label, infos, message, content } = Object.assign({ style: 'normal', message: 'Delete' }, props);
    const node = useRef(null);
    const [confirm, setConfirm] = useState(false);
    const [checked, setChecked] = useState(false);
    /**
     * @function isAccepted
     * @since 1.0.0
     * @hidden
     */
    function isAccepted() {
        var _a, _b, _c;
        return ((_c = (_b = (_a = node.current) === null || _a === void 0 ? void 0 : _a.querySelector('input[type=checkbox]')) === null || _b === void 0 ? void 0 : _b.checked) !== null && _c !== void 0 ? _c : false);
    }
    /**
     * @function onDelete
     * @since 1.0.0
     * @hidden
     */
    function onDelete() {
        setConfirm(true);
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(checked) {
        setChecked(checked);
    }
    /**
     * @function onCancel
     * @since 1.0.0
     * @hidden
     */
    function onCancel() {
        setConfirm(false);
        if (props.onCancel) {
            props.onCancel();
        }
    }
    /**
     * @function onAccept
     * @since 1.0.0
     * @hidden
     */
    function onAccept() {
        const accepted = isAccepted();
        if (accepted) {
            if (props.onAccept) {
                props.onAccept();
            }
            setConfirm(false);
            return;
        }
        if (node.current) {
            node.current.classList.add('form-delete--invalid');
        }
        setTimeout(() => {
            if (node.current) {
                node.current.classList.remove('form-delete--invalid');
            }
        }, 1000);
    }
    const className = classNames('form-delete', 'form-delete--' + style, props.className);
    return (React.createElement("div", { ref: node, className: className },
        React.createElement("div", { className: "form-delete-head" },
            React.createElement(FormFieldLabel, { className: "form-delete-label", style: style, label: label }),
            React.createElement(FormFieldInfos, { className: "form-delete-infos", style: style, infos: infos })),
        React.createElement("div", { className: "form-delete-body" },
            React.createElement(When, null,
                React.createElement(Case, { is: confirm },
                    React.createElement("div", { className: "form-delete-confirm" },
                        React.createElement(FormGroup, { className: "form-delete-confirm-check" },
                            React.createElement(FormField, null,
                                React.createElement(FormCheck, { name: "", label: message, onChange: onChange }))),
                        checked && content,
                        React.createElement(FormGroup, { className: "form-delete-confirm-tools" },
                            React.createElement(FormField, null,
                                React.createElement(ButtonGroup, null,
                                    React.createElement(Button, { style: "warning", label: t('Delete'), onPress: onAccept }),
                                    React.createElement(Button, { style: "normal", label: t('Cancel'), onPress: onCancel })))))),
                React.createElement(Else, null,
                    React.createElement("div", { className: "form-delete-request" },
                        React.createElement(Button, { style: "warning", label: t('Delete'), onPress: onDelete }),
                        React.createElement(Button, { style: "outline", label: t('Cancel'), onPress: onCancel })))))));
}
